<template>
  <div class="basic-info">
    <BaseHeaderBar
      title="Infomasi Dasar"
      :showCustomerService="false"
      :showBackButton="true"
    />
    <form class="form-content" @submit.prevent="onSubmit">
      <input
        v-model="name"
        type="text"
        :readonly="nameReadonly"
        maxlength="30"
        placeholder="Silakan masukkan nama"
        @focus="startFieldTracking('name', name)"
        @blur="finishFieldTracking('name', name)"
      />
      <input
        v-model.trim="ktp"
        type="tel"
        :readonly="ktpReadonly"
        minlength="16"
        maxlength="20"
        placeholder="Silakan masukkan NIK KTP"
        @focus="startFieldTracking('ktp', ktp)"
        @blur="finishFieldTracking('ktp', ktp)"
      />
      <input
        v-model.trim="whatsApp"
        type="tel"
        minlength="9"
        maxlength="13"
        placeholder="Silakan masukkan nomor Whatsapp"
        @focus="startFieldTracking('whatsApp', whatsApp)"
        @blur="finishFieldTracking('whatsApp', whatsApp)"
      />
      <input
        v-model.trim="mail"
        type="text"
        placeholder="Silakan masukkan email"
        @focus="startFieldTracking('mail', mail)"
        @blur="finishFieldTracking('mail', mail)"
      />
      <div class="select-block">
        <input
          type="text"
          readonly
          :value="education"
          placeholder="Silakan pilih pendidikan"
          @click="select('education')"
        />
        <img src="@/assets/img/arrow-down.png" class="arrow-down" />
      </div>
      <div class="select-block">
        <input
          type="text"
          readonly
          :value="marriage"
          placeholder="Silakan pilih status pernikahan"
          @click="select('marriage')"
        />
        <img src="@/assets/img/arrow-down.png" class="arrow-down" />
      </div>
      <div class="select-block">
        <input
          type="text"
          readonly
          :value="incomeSource"
          placeholder="Silakan pilih sumber penghasilan"
          @click="select('incomeSource')"
        />
        <img src="@/assets/img/arrow-down.png" class="arrow-down" />
      </div>
      <div class="select-block">
        <input
          type="text"
          readonly
          :value="residence"
          placeholder="Silakan pilih tipe rumahk"
          @click="select('residence')"
        />
        <img src="@/assets/img/arrow-down.png" class="arrow-down" />
      </div>
      <div class="select-block">
        <input
          type="text"
          readonly
          :value="address"
          placeholder="Silakan pilih alamat tempat tinggal"
          @click="openAddressSelector"
        />
        <img src="@/assets/img/arrow-down.png" class="arrow-down" />
      </div>
      <input
        v-model.trim="addressDetail"
        type="text"
        maxlength="30"
        placeholder="Silakan masukkan alamat lengkap tempat tinggal"
        @focus="startFieldTracking('addressDetail', addressDetail)"
        @blur="finishFieldTracking('addressDetail', addressDetail)"
      />
      <div class="select-block">
        <input
          type="text"
          readonly
          :value="loanUse"
          placeholder="Silakan pilih tujuan pinjaman"
          @click="select('loanUse')"
        />
        <img src="@/assets/img/arrow-down.png" class="arrow-down" />
      </div>
      <div class="select-block">
        <input
          type="text"
          readonly
          :value="annualIncome"
          placeholder="Silakan pilih pemasukan tahunan"
          @click="select('annualIncome')"
        />
        <img src="@/assets/img/arrow-down.png" class="arrow-down" />
      </div>
      <div class="select-block">
        <input
          type="text"
          readonly
          :value="profession"
          placeholder="Silakan pilih jenis pekerjaan"
          @click="select('profession')"
        />
        <img src="@/assets/img/arrow-down.png" class="arrow-down" />
      </div>
      <div class="select-block">
        <input
          type="text"
          readonly
          :value="industry"
          placeholder="Silakan pilih industri pekerjaan"
          @click="select('industry')"
        />
        <img src="@/assets/img/arrow-down.png" class="arrow-down" />
      </div>
      <input
        v-if="showCompany"
        v-model.trim="company"
        type="text"
        maxlength="30"
        placeholder="Silakan masukkan nama toko atau perusahaan"
        @focus="startFieldTracking('codrmpanyName', company)"
        @blur="finishFieldTracking('codrmpanyName', company)"
      />
      <input
        v-if="showCompany"
        v-model.trim="companyAddress"
        type="text"
        maxlength="30"
        placeholder="Silakan masukkan alamat lengkap toko atau perusahaan"
        @focus="startFieldTracking('codrmpanyAddress', companyAddress)"
        @blur="finishFieldTracking('codrmpanyAddress', companyAddress)"
      />
      <p class="desc">
        Silakan pilih 3 nomor berbeda dari daftar kontak Anda yang dapat
        dihubungi kapan pun, baik kerabat/teman/nomor pribadi lainnya untuk
        ditambahkan sebagai kontak darurat. Kontak darurat hanya digunakan untuk
        keperluan evaluasi.
      </p>
      <div v-for="n in 3" :key="n" class="contact">
        <div class="select-block">
          <input
            type="text"
            readonly
            :value="contact[n - 1].contactRelationship"
            placeholder="Silakan pilih hubungan dengan kontak darurat"
            @click="select('contact', n - 1)"
          />
          <img src="@/assets/img/arrow-down.png" class="arrow-down" />
        </div>
        <input
          v-show="!isSelect || contact[n - 1].contactName"
          v-model.trim="contact[n - 1].contactName"
          type="text"
          placeholder="Silakan Masukkan Nama Kontak Darurat"
          @input="handleInput($event, n - 1)"
          @copy.prevent
          @cut.prevent
          @paste.prevent
          @focus="startFieldTracking('contactName' + n, contact[n - 1].contactName)"
          @blur="finishFieldTracking('contactName' + n, contact[n - 1].contactName)"
          :maxlength="isSelect ? 0 : 99"
          :readonly="isSelect"
        />
        <div class="select-block">
          <input
            v-model.trim="contact[n - 1].contactPhone"
            type="tel"
            maxlength="13"
            placeholder="Masukkan nomor telepon dengan awalan 08"
            @copy.prevent
            @cut.prevent
            @paste.prevent
            @focus="startContactPhoneTracking(n)"
            @blur="finishContactPhoneTracking(n)"
            @click="toAddressBook(n)"
            :readonly="isSelect"
          />
          <img
            v-if="isSelect"
            src="@/assets/img/arrow-down.png"
            class="arrow-down"
          />
        </div>
      </div>
      <button type="button" class="confirm-btn" @click="onSubmit">Kirim</button>
    </form>
    <van-popup v-model="visible" round position="bottom" @closed="onPickerClosed">
      <van-picker
        show-toolbar
        :columns="columns[curSelectedKey]"
        cancel-button-text="Batal"
        confirm-button-text="Yakin"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
    </van-popup>
    <van-popup v-model="addressVisible" round position="bottom" @closed="onAddressClosed">
      <van-cascader
        v-model="cascaderValue"
        title="Silakan pilih alamat tempat tinggal"
        placeholder="Silakan pilih"
        :options="addressOptions"
        @close="onCloseDialog('addressVisible')"
        @change="onAddressChange"
        @finish="onFinish"
      />
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import { Popup, Picker, Cascader, Toast } from 'vant'
import { validatePhoneNumber, validateEmail, validateContactPhone } from '@/utils/validator'
import request from '@/utils/request'
import dialogVisible from '@/mixins/dialogVisible'
import webviewBack from '@/mixins/webviewBack'
import {
  createFormTracking,
  finishFormFieldTracking,
  getFormTrackingData,
  resetFormTracking,
  startFormFieldTracking
} from '@/utils/formTracking'

Vue.use(Popup)
Vue.use(Picker)
Vue.use(Cascader)
Vue.use(Toast)

let ktpStatus

const trackingFieldMap = {
  name: 'name',
  ktp: 'ktp',
  whatsApp: 'whatsapp',
  mail: 'email',
  education: 'education',
  marriage: 'marital',
  incomeSource: 'income',
  residence: 'residence',
  address: 'residentialarea',
  addressDetail: 'address',
  profession: 'worktype',
  industry: 'workindustry',
  annualIncome: 'yearincome',
  loanUse: 'usefunds',
  codrmpanyName: 'companyname',
  codrmpanyAddress: 'companyaddress'
}

for (let i = 1; i <= 3; i++) {
  trackingFieldMap[`contactName${i}`] = `name${i}`
  trackingFieldMap[`contactRelationship${i}`] = `relation${i}`
  trackingFieldMap[`contactPhone${i}`] = `phone${i}`
}

export default {
  name: 'BasicInfo',
  mixins: [dialogVisible, webviewBack],
  data () {
    return {
      showCompany: true,
      name: '',
      nameReadonly: false,
      ktp: '',
      ktpReadonly: false,
      whatsApp: '',
      mail: '',
      addressDetail: '',
      company: '',
      companyAddress: '',
      education: '',
      marriage: '',
      incomeSource: '',
      residence: '',
      loanUse: '',
      annualIncome: '',
      profession: '',
      industry: '',
      contact: [
        {
          contactRelationship: '',
          contactName: '',
          contactPhone: ''
        },
        {
          contactRelationship: '',
          contactName: '',
          contactPhone: ''
        },
        {
          contactRelationship: '',
          contactName: '',
          contactPhone: ''
        }
      ],
      address: '',
      columns: {
        education: [],
        marriage: [],
        incomeSource: [],
        residence: [],
        loanUse: [],
        annualIncome: [],
        profession: [],
        industry: [],
        contact: []
      },
      cascaderValue: '',
      addressOptions: [],
      curSelectedKey: '',
      addressVisible: false,
      contantList: [],
      isSelect: false,
      contactIndex: null,
      flag: false,
      tracking: createFormTracking(trackingFieldMap),
      shouldResetTracking: false
    }
  },
  computed: mapState(['userBKInfo']),
  created () {
    this.getBasicInfo()
    this.getProvince()
    this.getContantList()
  },
  watch: {
    profession (newValue) {
      if (newValue === 'Murid' || newValue === 'Tidak bekerja') {
        this.showCompany = false
      } else {
        this.showCompany = true
      }
    }
  },

  methods: {
    resetTracking () {
      resetFormTracking(this.tracking, trackingFieldMap)
    },
    startFieldTracking (field, value) {
      startFormFieldTracking(this.tracking, field, value)
    },
    finishFieldTracking (field, value) {
      finishFormFieldTracking(this.tracking, field, value)
    },
    getTrackingData () {
      const trackingData = getFormTrackingData(this.tracking, trackingFieldMap)
      if (this.profession === 'Murid' || this.profession === 'Tidak bekerja') {
        trackingData.companyname_duration = 0
        trackingData.companyname_revisenum = 0
        trackingData.companyname_reviseduration = 0
        trackingData.companyaddress_duration = 0
        trackingData.companyaddress_revisenum = 0
        trackingData.companyaddress_reviseduration = 0
      }
      return trackingData
    },
    getContactTrackingField (index, key) {
      return `contact${key}${index + 1}`
    },
    getContactTrackingValue (field) {
      const matched = field.match(/^contact(Name|Relationship|Phone)(\d)$/)
      if (!matched) return ''
      const contactItem = this.contact[Number(matched[2]) - 1]
      if (!contactItem) return ''
      const valueKey = `contact${matched[1]}`
      return contactItem[valueKey]
    },
    getSelectTrackingField (key, index) {
      if (key === 'contact') {
        return this.getContactTrackingField(index, 'Relationship')
      }
      return key
    },
    getTrackingValue (field) {
      if (field.indexOf('contact') === 0) {
        return this.getContactTrackingValue(field)
      }
      const fieldAlias = {
        codrmpanyName: 'company',
        codrmpanyAddress: 'companyAddress'
      }
      return this[fieldAlias[field] || field]
    },
    getContantList () {
      request.post('contantList')
        .then(res => {
          if (res.list.length > 0) {
            this.isSelect = true
          }
        })
    },
    getBasicInfo () {
      request.post('badrsicInfoPage')
        .then(res => {
          res.cudrstomerName && (this.nameReadonly = true)
          res.cudrstomerIdcard && (this.ktpReadonly = true)
          this.name = res.cudrstomerName
          this.ktp = res.cudrstomerIdcard
          this.education = res.cudrstomerEducation
          this.marriage = res.cudrstomer_marrystatus
          this.columns = {
            education: res.eddrucationList,
            marriage: res.madrrrystatusList,
            incomeSource: res.indrcomesourceList,
            residence: res.redrsidencetypeList,
            loanUse: res.usdreoffundsList,
            annualIncome: res.yedrarincomeList,
            profession: res.wodrrktypeList,
            industry: res.wodrrkindustryList,
            contact: res.redrlationshipList
          }
          ktpStatus = res.ktdrp_status
        })
    },
    getProvince () {
      request.post('obdrProvince')
        .then(res => {
          this.addressOptions = res.lidrst.map(item => (
            {
              text: item.prdrovincesName,
              value: item.p_id,
              children: []
            }
          ))
          this.getCity(this.addressOptions[0], res.lidrst[0].p_id).then(cityList => {
            this.getCounty(this.addressOptions[0].children[0], cityList[0].cdrID)
          })
        })
    },
    getCity (option, provinceId) {
      const postData = {
        pdrID: provinceId
      }
      return request.post('obdrCity', postData)
        .then(res => {
          option.children = res.lidrst.map(item => (
            {
              text: item.cidrtyName,
              value: item.cdrID,
              children: []
            }
          ))
          return res.lidrst
        }).catch(e => {
          throw e
        })
    },
    getCounty (option, cityId) {
      const postData = {
        cdrID: cityId
      }
      request.post('obdrCounty', postData)
        .then(res => {
          option.children = res.lidrst.map(item => (
            {
              text: item.codruntyName,
              value: item.c_id
            }
          ))
        })
    },
    validateContactPhone (contactPhone) {
      if (!contactPhone) {
        Toast('Masukkan nomor telepon dengan awalan 08')
        return false
      }
      if (!validateContactPhone(contactPhone)) {
        Toast('Format nomor salah')
        return false
      }
      if (contactPhone === this.userBKInfo.mobileBK) {
        Toast('Nomor kontak darurat tidak boleh sama dengan nomor pendaftaran')
        return false
      }
      if (this.contact.filter(item => item.contactPhone === contactPhone).length > 1) {
        Toast('Kedua nomor kontak darurat tidak boleh sama')
        return false
      }
      return true
    },
    validate () {
      if (!this.name) {
        Toast('Silakan masukkan nama')
        return false
      }
      if (!/^[A-Za-z\s]+$/.test(this.name)) {
        Toast('Format nama salah')
        return false
      }
      if (!this.ktp) {
        Toast('Silakan masukkan NIK KTP')
        return false
      }
      if (!/^\d{16,20}$/.test(this.ktp)) {
        Toast('Format NIK salah')
        return false
      }
      if (!this.whatsApp) {
        Toast('Silakan masukkan nomor Whatsapp')
        return false
      }
      if (!validatePhoneNumber(this.whatsApp)) {
        Toast('Format Whatsapp salah')
        return false
      }
      if (!this.mail) {
        Toast('Silakan masukkan email')
        return false
      }
      if (!validateEmail(this.mail)) {
        Toast('Format email salah')
        return false
      }
      if (!this.education) {
        Toast('Silakan pilih pendidikan')
        return false
      }
      if (!this.marriage) {
        Toast('Silakan pilih status pernikahan')
        return false
      }
      if (!this.incomeSource) {
        Toast('Silakan pilih sumber penghasilan')
        return false
      }
      if (!this.residence) {
        Toast('Silakan pilih tipe rumah')
        return false
      }
      if (!this.address) {
        Toast('Silakan pilih alamat tempat tinggal')
        return false
      }
      if (!this.addressDetail) {
        Toast('Silakan masukkan alamat lengkap tempat tinggal')
        return false
      }
      if (!this.loanUse) {
        Toast('Silakan pilih tujuan pinjaman')
        return false
      }
      if (!this.annualIncome) {
        Toast('Silakan pilih pemasukan tahunan')
        return false
      }
      if (!this.profession) {
        Toast('Silakan pilih jenis pekerjaan')
        return false
      }
      if (!this.industry) {
        Toast('Silakan pilih industri pekerjaan')
        return false
      }
      if (this.showCompany) {
        if (!this.company) {
          Toast('Silakan masukkan nama toko atau perusahaan')
          return false
        }
        if (!this.companyAddress) {
          Toast('Silakan masukkan alamat lengkap toko atau perusahaan')
          return false
        }
      }
      for (let i = 0; i < this.contact.length; i++) {
        if (!this.contact[i].contactRelationship) {
          Toast('Silakan pilih hubungan dengan kontak darurat')
          return false
        }
        if (!this.contact[i].contactName) {
          Toast('Silakan Masukkan Nama Kontak Darurat')
          return false
        }
        if (!this.validateContactPhone(this.contact[i].contactPhone)) {
          return false
        }
      }
      return true
    },
    select (key, index) {
      this.curSelectedKey = key
      index !== undefined && (this.contactIndex = index)
      const field = this.getSelectTrackingField(key, index)
      this.startFieldTracking(field, this.getTrackingValue(field))
      this.visible = true
    },
    // 限制不能输入除字母以外得字符
    handleInput (event, index) {
      const filteredText = event.target.value.replace(/[^a-zA-Z]/g, '')
      this.contact[index].contactName = filteredText
    },
    startContactPhoneTracking (index) {
      if (this.isSelect) return
      this.startFieldTracking(`contactPhone${index}`, this.contact[index - 1].contactPhone)
    },
    finishContactPhoneTracking (index) {
      if (this.isSelect) return
      this.finishFieldTracking(`contactPhone${index}`, this.contact[index - 1].contactPhone)
    },
    toAddressBook (index) {
      if (this.isSelect) {
        const contactIndex = index - 1
        const nameField = this.getContactTrackingField(contactIndex, 'Name')
        const phoneField = this.getContactTrackingField(contactIndex, 'Phone')
        this.startFieldTracking(nameField, this.getContactTrackingValue(nameField))
        this.startFieldTracking(phoneField, this.getContactTrackingValue(phoneField))
        this.$router.push({
          path: '/addressBook',
          query: {
            number: contactIndex,
            contact: JSON.stringify(this.contact)
          }
        })
      }
    },

    onSubmit () {
      if (!this.validate()) return
      if (this.flag) return
      this.flag = true
      const trackingData = this.getTrackingData()
      const postData = {
        usdrerName: this.name,
        usdrerIdcard: this.ktp,
        usdrerWhatsapp: this.whatsApp,
        usdrerEmail: this.mail,
        usdrerEducation: this.education,
        usdrerMarrystatus: this.marriage,
        usdrerIncomesource: this.incomeSource,
        usdrerResidencetype: this.residence,
        usdrerResidentialarea: this.address,
        usdrerAddress: this.addressDetail,
        usdrerWorktype: this.profession,
        usdrerWorkindustry: this.industry,
        usdrerYearincome: this.annualIncome,
        usdrerUseoffunds: this.loanUse,
        ktdrpStatus: ktpStatus,
        codrntactList: JSON.stringify(this.contact)
      }
      if (this.showCompany) {
        postData.codrmpanyName = this.company
        postData.codrmpanyAddress = this.companyAddress
      }
      request.post('badrsicInfosubmit', postData)
        .then(() => {
          return request.post('basicInfoTracking', trackingData).catch(() => false)
        })
        .then(() => {
          Toast('Pembaruan infomasi dasar berhasil')
          this.$router.back()
        }).finally(() => {
          this.flag = false
        })
    },
    onCancel () {
      this.onCloseDialog()
    },
    onConfirm (value) {
      const field = this.getSelectTrackingField(this.curSelectedKey, this.contactIndex)
      if (this.curSelectedKey === 'contact') {
        this.contact[this.contactIndex].contactRelationship = value
      } else {
        this[this.curSelectedKey] = value
      }
      this.finishFieldTracking(field, this.getTrackingValue(field))
      this.onCloseDialog()
      this.curSelectedKey = ''
      this.contactIndex = null
    },
    onPickerClosed () {
      if (!this.curSelectedKey) return
      const field = this.getSelectTrackingField(this.curSelectedKey, this.contactIndex)
      this.finishFieldTracking(field, this.getTrackingValue(field))
      this.curSelectedKey = ''
      this.contactIndex = null
    },
    openAddressSelector () {
      this.startFieldTracking('address', this.address)
      this.addressVisible = true
    },
    onAddressChange ({ value, selectedOptions, tabIndex }) {
      if (tabIndex === 0) {
        if (!selectedOptions[0].children.length) {
          this.getCity(selectedOptions[0], value).then(cityList => {
            this.getCounty(selectedOptions[0].children[0], cityList[0].cdrID)
          })
        }
      } else if (tabIndex === 1) {
        if (!selectedOptions[1].children.length) {
          this.getCounty(selectedOptions[1], value)
        }
      }
    },
    onFinish ({ selectedOptions }) {
      this.address = selectedOptions.map(option => option.text).join('/')
      this.finishFieldTracking('address', this.address)
      this.onCloseDialog('addressVisible')
    },
    onAddressClosed () {
      this.finishFieldTracking('address', this.address)
      this.onCloseDialog('addressVisible')
    }
  },
  beforeRouteEnter (to, from, next) {
    const emergencyContact = sessionStorage.getItem('emergencyContact')
    if (emergencyContact) {
      const { userphone, username, number } = JSON.parse(emergencyContact)
      next(vm => {
        vm.contact[number].contactPhone = userphone
        vm.contact[number].contactName = username || userphone
        const contactIndex = Number(number)
        const nameField = vm.getContactTrackingField(contactIndex, 'Name')
        const phoneField = vm.getContactTrackingField(contactIndex, 'Phone')
        vm.finishFieldTracking(nameField, vm.getContactTrackingValue(nameField))
        vm.finishFieldTracking(phoneField, vm.getContactTrackingValue(phoneField))
      })
      sessionStorage.removeItem('emergencyContact')
      return
    }
    next()
  },
  activated () {
    if (this.shouldResetTracking) {
      this.resetTracking()
      this.shouldResetTracking = false
    }
  },
  beforeRouteLeave (to, from, next) {
    this.shouldResetTracking = to.path !== '/addressBook'
    next()
  }

}
</script>

<style scoped lang="less">
.basic-info {
  overflow: auto;
}

.form-content {
  margin-top: 24px;
  padding-left: 30px;
  padding-right: 30px;
}

input {
  display: block;
  width: 100%;
  height: 88px;
  line-height: 88px;
  border: 2px solid #242d3c;
  border-radius: 8px;
  padding-left: 16px;
  box-sizing: border-box;
  font-size: 30px;
  color: #333;
  background-color: #fff;

  &:nth-child(n + 2) {
    margin-top: 16px;
  }

  &::placeholder {
    font-size: 26px;
    color: #d1d2dd;
  }
}

.select-block {
  position: relative;
  margin-top: 16px;

  .arrow-down {
    position: absolute;
    top: 50%;
    right: 16px;
    width: 23px;
    height: 18px;
    transform: translateY(-50%);
  }
}

.desc {
  line-height: 37px;
  margin-top: 30px;
  margin-bottom: 39px;
  font-size: 26px;
  color: #999;
}

.contact {
  margin-top: 50px;
}

.confirm-btn {
  .submit-bg-btn;
  margin-top: 80px;
  margin-bottom: 100px;
}
</style>
